
import { ExternalLink } from "lucide-react";
import { motion } from "framer-motion";

const BusinessPartnerSection = () => {
  const partnerOptions = [
    {
      title: "METRADE MATCH",
      description: "Connect with trading experts and grow your business together",
      image: "/lovable-uploads/784423dc-bef8-4292-b434-9483bea0ae06.png",
      url: "https://match.metrade.io",
      position: "center",
    },
    {
      title: "METRADE LINK",
      description: "Promote trading strategies and earn commissions",
      image: "/lovable-uploads/fc3e63e2-3962-4cb4-a435-e90358dc24b0.png",
      url: "https://link.metrade.io",
      position: "center",
    },
  ];

  return (
    <section className="py-24 px-4 bg-corporate-primary-100 border-t border-corporate-primary-75/20">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-corporate-white mb-4">
            Become a Business Partner
          </h2>
          <p className="text-corporate-neutral-25 text-lg max-w-2xl mx-auto">
            Join our network of partners and grow your business with METRADE
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {partnerOptions.map((option, index) => (
            <motion.div
              key={option.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 + 0.3 }}
            >
              <a 
                href={option.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="block h-full"
              >
                <div 
                  className="rounded-xl overflow-hidden shadow-lg h-full hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group relative"
                  style={{
                    backgroundImage: `url(${option.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '300px',
                  }}
                >
                  {/* Darker gradient overlay for better text readability */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                  
                  <div className="p-6 md:p-8 flex flex-col h-full relative z-10">
                    <div className="mb-4 flex justify-between items-start">
                      <h3 className="text-2xl md:text-3xl font-bold text-corporate-white tracking-wide">{option.title}</h3>
                      <ExternalLink className="text-corporate-secondary-100 w-6 h-6 transform group-hover:translate-x-1 transition-transform duration-300" />
                    </div>
                    <p className="text-corporate-neutral-25 text-lg md:text-xl mb-6 flex-grow font-medium">{option.description}</p>
                  </div>
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessPartnerSection;
